import Api from '@/api/index';

const Truck = {
  namespaced: true,
  state: { //dado read only, e qm pode alterar esses dados são as mutations! VARIAVEIS
    oneTruck: null,
    allTrucks: null,
    rorMessage: null,
    errorActive: null,

    updateConfirmation: null,
    updateMessage: null,
  },
  mutations: {// altera os dados do state
    doSomething(state, someCar){
      state.oneTruck = someCar;
    },
    getTrucks(state, trucksA){
      state.allTrucks = trucksA.data; //trucksA é o trucks que veio da action
    },
    pushTruck(state, truck){
      state.allTrucks.push(truck);
    },
    getOneTruck(state, truck) {
      state.oneTruck = truck.data;
    },

    setErrorMessage(state, {message, status}){
      state.errorMessage = message;
      state.errorActive = status;
      setTimeout(() => {
        state.errorActive = null
      }, 100);
    },
    updateStatus(state, {status, msg}){
      state.updateConfirmation = status
      state.updateMessage = msg
      setTimeout(() => {
        state.updateConfirmation = null
        state.updateMessage = null
      }, 500);
    },
    clearTruck(state){
      state.oneTruck = null;
    },
    clearAllTrucks(state){
      state.allTrucks = null;
    },
    clearMsg(state){
      state.updateConfirmation = null
      state.updateMessage = null
    },
  },
  actions: { //chamar o método dentro dos componentes
    doMutation(context, otherCar){
      context.commit('doSomething', otherCar)//o commit chama a mutation!!
    },
    index (context) {
      Api.Truck.index()
        .then(response => response.data)
        .then(trucks => {
          context.commit('getTrucks', trucks);
          // context.commit('setErrorMessage', {message: '',status: false});
        }).catch(function(error) {
          console.log(error);
        });
    },
    create(context, {newTruck}){
      Api.Truck.create(newTruck)
        .then(response => response.data)
        .then(truck => {
          context.commit('pushTruck', {attributes: truck});
          context.commit('setErrorMessage', {message: '', status: false});
        }).catch(function(error) {
          console.log(error);
        });
    },
    show(context, truck_id) {
      Api.Truck.show(truck_id)
        .then(response => response.data)
        .then(truck => {
          context.commit('getOneTruck', truck);
          context.commit('setErrorMessage', {message: '', status: false});
        }).catch(function(error) {
          console.log(error);
        });
    },
    update(context, {kind, index, id, truck}){
      if (kind == 'info'){
        Api.Truck.updateInfo(truck, id)
        .then(response => response.data)
        .then(truck => {
          context.commit('updateStatus', {status: true, msg: 'Updated'});
        }).catch(function(error) {
          console.log(error);
          context.commit('updateStatus', {status: true, msg: 'Updated'});
        });
      } else if(kind == 'load'){
        Api.Truck.updateLoad(truck, id)
        .then(response => response.data)
        .then(truck => {
          context.commit('updateStatus', {status: true, msg: 'Updated'});
        }).catch(function(error) {
          console.log(error);
          context.commit('updateStatus', {status: true, msg: 'Updated'});
        });
      } else if(kind == 'document'){
        Api.Truck.updateDocuments(truck, id)
        .then(response => response.data)
        .then(truck => {
          context.commit('updateStatus', {status: true, msg: 'Updated'});
        }).catch(function(error) {
          console.log(error);
          context.commit('updateStatus', {status: true, msg: 'Updated'});
        });
      }
    },
    clearTruck(context){
      context.commit('clearTruck')
    },
    clearAllTrucks(context){
      context.commit('clearAllTrucks')
    },
    clearUpdateMessage(context){
      context.commit('clearMsg')
    }
  }
};

export default Truck;